import { LoginIcon } from './LoginIcon';

/**
 * author: Google
 * id 63D8BFA5-7AE4-4002-A4C2-C464638C38FC
 * name login
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/login.svg
 * tags
 */
export const SignInIcon = LoginIcon;
export default SignInIcon